import { TweenMax } from "gsap"

const [w,d] = [window, document];
/*
カーソルに追従するアニメーション
*/
export default function CURSOR_FOLLOWER(delay_time){

  const
    cursor = d.createElement('div'),
    chaser = d.createElement('div');

  cursor.classList.add('js-cursor');
  chaser.classList.add('js-chaser');

  d.body.insertBefore(cursor, d.body.firstChild);
  d.body.insertBefore(chaser, d.body.firstChild);

  let
    delay = delay_time,
    cursorPosX = 0,
    cursorPosY = 0,
    chaserPosX = 0,
    chaserPosY = 0

  // カーソルの遅延アニメーション
  TweenMax.to({}, 0.01, {
    repeat: -1,
    onRepeat() {
      chaserPosX += (cursorPosX - chaserPosX) / delay
      chaserPosY += (cursorPosY - chaserPosY) / delay

      TweenMax.set(cursor, {
        css: {
          left: cursorPosX - (cursor.clientWidth / 2),
          top: cursorPosY - (cursor.clientWidth / 2)
        }
      })

      TweenMax.set(chaser, {
        css: {
          left: chaserPosX - (chaser.clientWidth / 2),
          top: chaserPosY - (chaser.clientWidth / 2)
        }
      })
    }
  })

  // マウス座標を取得
  document.onmousemove = event => {
    cursorPosX = event.pageX
    cursorPosY = event.pageY
  }

  $(document).on({
    mouseenter() {
      cursor.classList.add("is-active")
      chaser.classList.add("is-active")
    },
    mouseleave() {
      cursor.classList.remove("is-active")
      chaser.classList.remove("is-active")
    }
  }, "a,button");
}